import { useState } from 'react'

import { getAPIClient } from 'api/axios'

import { Coupon } from '../types/coupon'
import { couponErrorMessage } from './couponErrorMessage'

interface UseFinishCouponReturn {
  finishCoupon: (uuid: string) => Promise<Coupon | null>
  loading: boolean
  error: string | null
}

export const useFinishCoupon = (): UseFinishCouponReturn => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const client = getAPIClient()

  const finishCoupon = async (uuid: string): Promise<Coupon | null> => {
    setLoading(true)
    setError(null)

    try {
      const response = await client.post(`/v1/coupons/${uuid}/finish`)
      return response.data.record ?? response.data.coupon
    } catch (err: any) {
      const message = couponErrorMessage(err, 'Erro ao finalizar cupom')
      setError(message)
      throw message
    } finally {
      setLoading(false)
    }
  }

  return { finishCoupon, loading, error }
}
